import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { API_URL } from '../config';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await axios.post(`${API_URL}/auth/forgot-password`, { email });
            setSubmitted(true);
        } catch (err) {
            // Always show success (prevents email enumeration)
            setSubmitted(true);
        }
        setLoading(false);
    };

    // Success View
    if (submitted) {
        return (
            <div className="auth-page">
                <div className="auth-card" style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '48px', marginBottom: '20px' }}>📧</div>
                    <h2 className="auth-title">Check Your Email</h2>
                    <p className="auth-subtitle" style={{ marginBottom: '20px' }}>
                        If an account exists for <strong style={{ color: 'var(--text)' }}>{email}</strong>, we've sent a password reset link.
                    </p>
                    <p style={{ fontSize: '13px', color: 'var(--text-muted)', marginBottom: '32px' }}>
                        The link expires in 1 hour. Check your spam folder if you don't see it.
                    </p>
                    <button onClick={() => navigate('/')} className="btn-primary" style={{ width: '100%' }}>
                        Back to Login
                    </button>
                </div>
            </div>
        );
    }

    // Main Form View
    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="auth-brand fade-up delay-1">
                    <h1 className="auth-logo">infloir</h1>
                    <p className="auth-tagline">Global Task Marketplace</p>
                </div>

                <div className="fade-up delay-2">
                    <h2 className="auth-title">Forgot Password</h2>
                    <p className="auth-subtitle">Enter your email and we'll send you a reset link.</p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-field fade-up delay-3">
                        <label className="form-label" htmlFor="email">Email</label>
                        <input
                            id="email"
                            type="email"
                            placeholder="you@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <div className="fade-up delay-4">
                        <button type="submit" className="btn-primary auth-submit" disabled={loading}>
                            {loading ? 'Sending...' : 'Send Reset Link'}
                        </button>
                    </div>
                </form>

                <div className="fade-up delay-5">
                    <p className="auth-footer-text" style={{ marginTop: '24px' }}>
                        Remember your password? <Link to="/">Sign in</Link>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;